import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import { useParams } from 'react-router';
import SelectRegister from 'react-select';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { useLocation } from 'react-router';

const CreateRiskProfileComp = (props) => {
  // console.log(props);
  const routeParams = useParams();

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [listRiskRegister, setlistRiskRegister] = useState('');
  const [idRiskRegister, setidRiskRegister] = useState('');
  const [rootCause, setrootCause] = useState('');
  const [controlStatus, setcontrolStatus] = useState('');

  const location = useLocation();
  const [role, setRole] = useState('');

  const fetchlistByFk = async () => {
    try {
      const options = {
        url: `/risk-register/listByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setlistRiskRegister([]);
      data.map((d) =>
        setlistRiskRegister((listRiskRegister) => [
          ...listRiskRegister,
          {
            label: d.riskStatement,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchlistByFk();
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  const handleCreateRiskProfile = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idRiskRegister: idRiskRegister?.value,
      rootCause: rootCause,
      controlStatus: controlStatus,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: '/risk-profile/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully tambah laporan!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="controlStatus" className="form-label required">
              Pernyataan Risiko
            </label>
            <SelectRegister
              id="controlStatus"
              value={idRiskRegister}
              onChange={setidRiskRegister}
              options={listRiskRegister}
              placeholder="Cari pernyataan"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="rootCause" className="form-label required">
              Akar Masalah
            </label>
            <textarea
              className="form-control row-cols-3"
              id="rootCause"
              onChange={(e) => setrootCause(e.target.value)}
              value={rootCause}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="controlStatus" className="form-label required">
              Deteksi
            </label>
            <select
              className="form-select"
              id="controlStatus"
              onChange={(e) => setcontrolStatus(e.target.value)}
            >
              <option selected disabled>
                Pilih
              </option>
              <option value={4}>Mudah</option>
              <option value={3}>Sedang Mudah</option>
              <option value={2}>Sedang Sulit</option>
              <option value={1}>Sulit</option>
            </select>
          </div>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleCreateRiskProfile()}
          >
            <IconDeviceFloppy stroke={2} />{' '}
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateRiskProfileComp;
